export const environment = {
	firebaseConfig: {
		apiKey: 'AIzaSyBa17FY2fiwgEeq-jgl3xvZ4dPsIb-W1Rg',
		authDomain: 'taxa-turistica.firebaseapp.com',
		projectId: 'taxa-turistica',
		storageBucket: 'taxa-turistica.appspot.com',
		messagingSenderId: '148120155425',
		appId: '1:148120155425:web:9aa874e4c2dcb16c2f7a60',
		measurementId: 'G-WD10Z0PKCF'
	},
	urlPlan: 'https://www.misericordiassaude.pt/',
	production: false,
	baseUrl: 'https://apipp.360city.pt/apitt/',
	callbackUrl: 'https://pttpp.360city.pt/',
	app: 'wpay-taxa-turistica',
	appName: 'PWA Taxa Turística Alojamento',
	version: '1.0.12-244'
};
